import { AppSettings } from '../types';
import { getApiBaseUrl, getAuthHeaders } from '../config/api';

export const settingsService = {
  /**
   * Buscar configurações do backend
   */
  async getAppSettings(): Promise<AppSettings | null> {
    try {
      const response = await fetch(`${getApiBaseUrl()}/settings`, {
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('❌ Erro ao buscar settings do backend:', error);
      return null;
    }
  },

  /**
   * Salvar configurações no backend
   */
  async saveAppSettings(settings: AppSettings): Promise<void> {
    try {
      const response = await fetch(`${getApiBaseUrl()}/settings`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
        },
        body: JSON.stringify(settings),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      console.log('✅ Configurações salvas com sucesso');
    } catch (error) {
      console.error('❌ Erro ao salvar settings:', error);
      throw error;
    }
  },

  /**
   * Testar envio de e-mail com configurações atuais
   */
  async testEmail(recipient?: string, recipients?: string[]): Promise<{ success: boolean; message?: string; error?: string; recipients?: string[] }> {
    try {
      const body: { recipient?: string; recipients?: string[] } = {};

      if (recipients && recipients.length > 0) {
        body.recipients = recipients;
      } else if (recipient) {
        body.recipient = recipient;
      }

      const response = await fetch(`${getApiBaseUrl()}/email/test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || `HTTP error! status: ${response.status}`,
        };
      }

      return data;
    } catch (error) {
      console.error('❌ Erro ao testar e-mail:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro desconhecido',
      };
    }
  },

  /**
   * Buscar layout do dashboard (localStorage por enquanto, pode migrar para backend)
   */
  async getDashboardLayout(): Promise<any[]> {
    try {
      const stored = localStorage.getItem('dashboard_layout');
      return stored ? JSON.parse(stored) : ['kpis', 'activities', 'tenders', 'contracts'];
    } catch (error) {
      console.error('❌ Erro ao buscar layout do dashboard:', error);
      return ['kpis', 'activities', 'tenders', 'contracts'];
    }
  },

  /**
   * Salvar layout do dashboard (localStorage por enquanto, pode migrar para backend)
   */
  async saveDashboardLayout(layout: any[]): Promise<void> {
    try {
      localStorage.setItem('dashboard_layout', JSON.stringify(layout));
      console.log('✅ Layout do dashboard salvo com sucesso');
    } catch (error) {
      console.error('❌ Erro ao salvar layout do dashboard:', error);
      throw error;
    }
  },
};
